var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-chart-3"},[_c('div',{staticClass:"lc1-header"},[_vm._v("线上参与人数")]),_c('div',{staticClass:"lc1-details"},[_c('dv-digital-flop',{attrs:{"config":_vm.config}})],1),_c('dv-decoration-2',{staticStyle:{"height":"10px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }